import React, { useEffect, useState } from "react"
import DataTable from "react-data-table-component"
import _ from "lodash"
import {
  collection,
  getDocs,
  query,
  where,
  setDoc,
  doc,
} from "firebase/firestore"
import { db, storage } from "../../Firebase/Firebase-config"
import {
  ref,
  listAll,
  getDownloadURL,
  uploadBytes,
  storageRef,
  deleteObject,
} from "firebase/storage"

const TableConfig = (refresh, isAddNew) => {
  const [allBlogs, setAllBlogs] = useState([])
  const [contact, setContact] = useState([])
  const contactRef = collection(db, "contact-us")
  const dbCollectionRef = collection(db, "blogs")
  const imageListRef = ref(storage, "blog-images/")
  const [delAction, setDelAction] = useState(false)
  const [blogIndex, setBlogIndex] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [isLoader, setIsLoader] = useState(false)

  const [img, setImg] = useState()
  const [values, setValues] = useState({
    tittle: "",
    description: "",
    date: "",
    comments: [
      {
        uName: "",
        uComments: "",
      },
    ],
    likes: 0,
    thumbnail: "",
    category: "",
    delete: false,
  })
  // const [getImage, setGetImage] = useState()

  const getAllBlogs = async () => {
    // setAllBlogs([])
    // get all blogs
    const q = query(dbCollectionRef, where("delete", "==", false))
    const data = await getDocs(q)
    setAllBlogs(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))

    const qc = query(contactRef, where("delete", "==", false))
    const contactData = await getDocs(qc)
    setContact(contactData.docs.map((doc) => ({ ...doc.data(), id: doc.id })))

    // getimages
    listAll(imageListRef).then((res) => {
      res.items.forEach((item) => {
        getDownloadURL(item).then((url) => {
          // setGetImage(url)
          const index = allBlogs.findIndex((blog) =>
            _.isEqual(blog.thumbnail, item.name)
          )
          if (index !== -1) {
            setAllBlogs((prevAllBlogs) =>
              prevAllBlogs.map((blog, i) =>
                i === index ? { ...blog, url: url } : blog
              )
            )
          } else {
            setAllBlogs((prevAllBlogs) =>
              prevAllBlogs.map((blog) => ({ ...blog, url: "" }))
            )
            // getAllBlogs()
          }
          setAllBlogs((prevAllBlogs) =>
            prevAllBlogs.map((blog) => ({ ...blog, imageInfo: item.name }))
          )
        })
      })
    })
  }

  // remove blog
  const remove = async (e) => {
    setDelAction(true)
    for (let i in allBlogs) {
      if (allBlogs[i].id === e) {
        console.log(allBlogs[i].imageInfo)
        setBlogIndex(i)
      }
    }
  }
  // delete
  const deleteBlog = async () => {
    const docRef = doc(db, "blogs", allBlogs[blogIndex].id)
    const delUser = allBlogs[blogIndex]
    delUser.delete = true
    await setDoc(docRef, delUser)
    console.log(delUser)
    setDelAction(false)
    getAllBlogs()

    // Create a reference to the file to delete
    const desertRef = ref(
      storage,
      "blog-images/" + allBlogs[blogIndex].imageInfo
    )

    // Delete the file
    deleteObject(desertRef)
      .then(() => {
        // File deleted successfully
        console.log("deleted successfully")
      })
      .catch((error) => {
        // Uh-oh, an error occurred!
        console.log(error)
      })
  }

  // editBlog
  function edit(e) {
    setIsEdit(true)
    for (let i in allBlogs) {
      if (allBlogs[i].id === e) {
        console.log(e, allBlogs[i].id)
        setBlogIndex(i)
      }
    }
  }
  const editBlogSave = async () => {
    setIsLoader(true)
    const docRef = doc(db, "blogs", allBlogs[blogIndex].id)
    await setDoc(docRef, values)
    setIsLoader(false)
    setIsEdit(false)
    // getAllBlogs()
  }

  useEffect(() => {
    if (refresh.refresh) {
      // console.log(refresh)
    } else {
      getAllBlogs()
    }
  }, [allBlogs.length, refresh])

  const ImageCell = ({ value }) => (
    <img src={value} alt="thumbnail" style={{ height: "80px" }} />
  )

  const DesCell = ({ value }) => (
    <>
      {_.truncate(value, {
        length: 50,
        separator: " ",
        omission: "...",
      })}
    </>
  )

  const mainColumns = [
    {
      id: 1,
      name: "Thumbnail",
      selector: "image",
      cell: (row) => <ImageCell value={row.url} />,
      sortable: false,
      reorder: false,
    },
    {
      id: 2,
      name: "Tittle",
      selector: (row) => row.tittle,
      sortable: true,
      reorder: true,
    },
    {
      id: 3,
      name: "Description",
      selector: (row) => <DesCell value={row.description} />,
      sortable: true,
      reorder: true,
    },
    {
      id: 4,
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
      reorder: true,
    },
    {
      id: 5,
      name: "Category",
      selector: (row) => row.category,
      sortable: true,
      reorder: true,
    },
    {
      id: 6,
      name: "Action",
      // selector: (row) => row.paid,
      cell: (row) => (
        <div className="flex bg-white space-x-2 border-2 shadow-sm shadow-gray-700 rounded-lg p-2">
          <svg
            onClick={() => edit(row.id)}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            className="w-6 h-6 hover:cursor-pointer"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
            />
          </svg>

          <svg
            onClick={() => remove(row.id)}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            className="w-6 h-6 hover:cursor-pointer"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
            />
          </svg>
        </div>
      ),
      sortable: false,
      reorder: true,
    },
  ]

  const userColumns = [
    {
      id: 1,
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      reorder: true,
    },
    {
      id: 2,
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      reorder: true,
    },
    {
      id: 3,
      name: "Message",
      selector: (row) => row.message,
      sortable: true,
      reorder: true,
    },
    // {
    //   id: 5,
    //   name: "Action",
    //   // selector: (row) => row.paid,
    //   cell: (row) => (
    //     <div className="flex bg-white space-x-2 border-2 shadow-sm shadow-gray-700 rounded-lg p-2">
    //       <svg
    //         onClick={() => edit(row.id)}
    //         xmlns="http://www.w3.org/2000/svg"
    //         fill="none"
    //         viewBox="0 0 24 24"
    //         stroke-width="1.5"
    //         stroke="currentColor"
    //         className="w-6 h-6 hover:cursor-pointer"
    //       >
    //         <path
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //           d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
    //         />
    //       </svg>

    //       <svg
    //         onClick={() => remove(row.id)}
    //         xmlns="http://www.w3.org/2000/svg"
    //         fill="none"
    //         viewBox="0 0 24 24"
    //         stroke-width="1.5"
    //         stroke="currentColor"
    //         className="w-6 h-6 hover:cursor-pointer"
    //       >
    //         <path
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //           d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    //         />
    //       </svg>
    //     </div>
    //   ),
    //   sortable: false,
    //   reorder: true,
    // },
  ]

  return (
    <>
      <div>
        <DataTable
          title="All Blogs"
          columns={mainColumns}
          data={allBlogs}
          pagination
          fixedHeader
          fixedHeaderScrollHeight="480px"
        />
        <hr className="h-[2px] bg-gray-600" />
        <DataTable
          title="Users Contact"
          columns={userColumns}
          data={contact}
          pagination
          fixedHeader
          fixedHeaderScrollHeight="480px"
        />
      </div>

      {delAction && (
        <div className="absolute inset-0 bg-black bg-opacity-50 z-10 flex pt-28 justify-center">
          <div className="bg-white w-1/3 p-4 h-fit rounded-lg">
            <div className="flex flex-col space-y-5">
              <span className="text-xl font-semibold uppercase font-mono">
                !Inportant
              </span>
              <span>Are you sure to delete this record</span>
            </div>
            <div className="flex justify-end space-x-4 pt-4 font-mono">
              <button
                className="font-semibold hover:border-black rounded-3xl border border-slate-500 py-2 px-5"
                onClick={() => setDelAction(false)}
              >
                Cancel
              </button>
              <button
                className="bg-primary font-semibold hover:border-black rounded-3xl border border-slate-500 py-2 px-5"
                onClick={() => deleteBlog()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {isEdit && (
        <div
          className={`absolute inset-0 z-10 overflow-hi dden bg-transparent bg-opacity-60 backdrop-blur-sm bg-white flex flex-col justify-center items-center ${
            isAddNew
              ? "translate-x-0 transform duration-600"
              : "translate-x-full"
          }`}
        >
          <div className="flex flex-col md:w-2/4 w-11/12 space-y-4 border-2 p-5 bg-secondary shadow-lg drop-shadow-xl shadow-primary">
            <div className="relative w-full flex justify-end -mt-8 ml-7 rounded-full">
              <svg
                className="w-7 h-7 p-1 border-2 bg-white hover:cursor-pointer"
                onClick={() => {
                  setIsEdit(false)
                }}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
            <span>Tittle</span>
            <input
              type="text"
              className="border-2 border-gray-400 h-8"
              value={blogIndex ? allBlogs[blogIndex].tittle : ""}
              onChange={(e) => {
                setValues((tittle) => ({
                  ...tittle,
                  tittle: e.target.value,
                }))
              }}
            />
            <span>Description</span>
            <textarea
              name="blog"
              id="blog"
              cols="30"
              rows="10"
              className="border-2 border-gray-400"
              value={blogIndex ? allBlogs[blogIndex].description : ""}
              onChange={(e) => {
                setValues((description) => ({
                  ...description,
                  description: e.target.value,
                }))
              }}
            ></textarea>
            <span>Upload New Image</span>
            <img
              src={blogIndex ? allBlogs[blogIndex].url : ""}
              alt="img"
              className="w-8 h-6"
            />
            <input
              type="file"
              className="border-2 border-gray-400 h-8"
              onChange={(e) => {
                setImg(e.target.files[0])
              }}
              accept="image/*"
            />
            <div className="space-x-4">
              <label htmlFor="category-select">Select a category:</label>
              <select
                className="bg-medium p-1 border-2"
                id="category-select"
                value={values.category}
                onChange={(e) => {
                  setValues((category) => ({
                    ...category,
                    category: e.target.value,
                  }))
                }}
              >
                <option value="all-post">
                  Choose a category "(default: All Post)"
                </option>
                <option value="health-wellness">Health & Wellness</option>
                <option value="travel">Travel</option>
                <option value="culture">Culture</option>
              </select>
            </div>
            <button
              className="border-2 bg-primary py-2 shadow-lg hover:shadow-primary"
              onClick={() => {
                editBlogSave()
              }}
            >
              {!isLoader ? "Option will comming soon" : "Loading..."}
            </button>
          </div>
        </div>
      )}
    </>
  )
}

export default TableConfig
